<template>
  <div class="other">
    <div class="wrap" v-show='!defaut'>
      <div class="othericon" @click="kefu">
        <img src="../assets/img/kefu-icon@2x.png" alt="">
        联系客服
      </div>
      <!-- <div class="othericon" @click="xiaofei">
        <img src="../assets/img/jilu-icon@2x.png" alt="">
        消费记录
      </div> -->
    </div>
    <div class="defautwrap" v-show='defaut'>
      <div class="topnav">
        <img src="../assets/img/fh-icon@2x.png" alt="" @click="defaut=false">
        客服中心
      </div>
      <div class="kefumess martop">
        <img src="../assets/img/kefu-icon@2x.png" alt="">
        <span>
          如果您遇到了任何关于游戏或 者返利等问题，都可以通过添加客服QQ，进行咨询
        </span>
      </div>
      <div class="QQnum martop" @click="goqq">
        <div>在线客服QQ号</div> <div>{{qqnumber}}
          <img src="../assets/img/icon@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Other',
  data(){
    return{
      defaut:false,
      osType:'',
      qqnumber:''
    }
  },
  created(){
    if(this.$route.query.osType){
      this.osType = this.$route.query.osType
      this.qqnumber = this.$route.query.qqnum
     }
  },
  methods:{
    goqq(){
      if(this.osType == 1){
        try{
          window.SDK.openqq(this.number)
        }catch(error){
          console.log(error)
        } 
      }else if(this.osType == 2){
        try{
          window.webkit.messageHandlers.openqq.postMessage(this.number);
        }catch(error){
          console.log(error)
        }
      }
    },
    kefu(){
      this.defaut = true
    },
    xiaofei(){
      if(this.osType == 1){
        try{
          window.SDK.gopaymoney()
        }catch(error){
          console.log(error)
        }
      }else if(this.osType == 2){
        try{
          window.webkit.messageHandlers.gopaymoney.postMessage(this.number);
        }catch(error){
          console.log(error)
        }
      }
      
    }
  }
}
</script>
<style lang="less" scoped>
  .other{
    font-size: 0.65rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .wrap{
      width: 100%;
      height: 100%;
      background: #fff;
      padding: 0.75rem 1.25rem 0 1.25rem;
      .othericon{
        width: 2.9rem;
        float: left;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        margin-right: 2.25rem;
        img{
          width: 2.9rem;
          height: 2.9rem;
        }
        &:nth-child(3n){
          margin-right: auto;
        }
      }
    }
    .defautwrap{
      width: 100%;
      height: 100%;
      background: #F7F8F9;
      // padding: 0.75rem 1.25rem 0 1.25rem;
      .topnav{
        width: 100%;
        height: 2.25rem;
        background:#fff;
        text-align: center;
        line-height: 2.25rem;
        font-size:0.8rem;
        color:rgba(17,17,17,1);
        position: relative;
        img{
          height: 0.75rem;
          display: block;
          position: absolute;
          left: 0.75rem;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      // .topnav::before{
      //   width: 0.45rem;
      //   height: 0.75rem;
      //   content:'';
      //   display: block;
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   bottom: 0;
      //   margin: auto;
      //   background: url(../assets/img/icon.png) no-repeat left center;
      //   background-size:  0.45rem 0.75rem;
      // }
      .QQnum{
        width:92%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 2.5rem;
        background: #fff;
        border-radius: 0.6rem;
        box-shadow:0rem 1px 0rem 0rem rgba(229,229,229,1);
        margin: 0 auto;
        padding: 0.48rem;
        div{
          img{
            height: 0.63rem;
            vertical-align: middle;
          }
        }
        &.martop{
          margin-top: 0.5rem;
        }
      }
      .kefumess{
        width: 92%;
        background: #fff;
        border-radius: 0.6rem;
        box-shadow:0rem 1px 0rem 0rem rgba(229,229,229,1);
        margin: 0 auto;
        padding: 0.48rem;
        display: flex;
        align-items: center;
        img{
          width: 1.7rem;
          height: 1.7rem;
          margin-left: 0;
          margin-right: 0.78rem;
          vertical-align: middle;
        }
        &.martop{
          margin-top: 0.5rem;
        }
      }
    }
  }
  
</style>
